"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getValidators = void 0;
var fp_1 = require("lodash/fp");
var env_1 = require("../../../env");
var network_1 = __importDefault(require("../../../network"));
var URLS = {
    validatorList: function (cluster) {
        var clusterSlug = cluster === "mainnet-beta" ? "mainnet" : cluster;
        var baseUrl = (0, env_1.getEnv)("SOLANA_VALIDATORS_APP_BASE_URL");
        return "".concat(baseUrl, "/").concat(clusterSlug, ".json");
    }
};
function getValidators(cluster) {
    return __awaiter(this, void 0, void 0, function () {
        var config, response, allRawValidators, tryFromRawValidator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = {
                        method: "GET",
                        url: URLS.validatorList(cluster)
                    };
                    return [4 /*yield*/, (0, network_1["default"])(config)];
                case 1:
                    response = _a.sent();
                    allRawValidators = response.status === 200 ? response.data : [];
                    tryFromRawValidator = function (v) {
                        var _a, _b, _c;
                        if (typeof v.active_stake === "number" &&
                            typeof v.commission === "number" &&
                            typeof v.total_score === "number" &&
                            typeof v.vote_account === "string" &&
                            v.delinquent !== true) {
                            return {
                                activeStake: v.active_stake,
                                commission: v.commission,
                                totalScore: v.total_score,
                                voteAccount: v.vote_account,
                                name: (_a = v.name) !== null && _a !== void 0 ? _a : undefined,
                                avatarUrl: (_b = v.avatar_url) !== null && _b !== void 0 ? _b : undefined,
                                wwwUrl: (_c = v.www_url) !== null && _c !== void 0 ? _c : undefined
                            };
                        }
                        return undefined;
                    };
                    // FIXME Ordering of validators must be always the same, for this test to be stable:
                    // https://github.com/LedgerHQ/ledger-live-common/blob/develop/src/__tests__/test-helpers/bridge.ts#L171-L188
                    return [2 /*return*/, (0, fp_1.compact)(allRawValidators.map(tryFromRawValidator))];
            }
        });
    });
}
exports.getValidators = getValidators;
//# sourceMappingURL=index.js.map